"use client";

import React, { type ReactElement } from "react";
import {
  MoreSectionPrimary,
  MoreSectionSecondary,
  GlobalPageHeader,
} from "@/components";
import { useTranslations } from "next-intl";

function MoreMain(): ReactElement {
  const t = useTranslations("more.Page");
  return (
    <div className="flex flex-col gap-2 bg-background">
      <GlobalPageHeader title={t("title")} lead={t("lead")} />
      <MoreSectionPrimary />
      <MoreSectionSecondary />
    </div>
  );
}

export { MoreMain };
